/*!**************************Confidential and Proprietary*****************************
* File Name: DataChart.ts
********************Copyright (c) Hyland Software, Inc. 1992-2023********************/

import { DataChartModel, CHART_TYPE } from './Models'
import { BarChart } from './BarChart'
import { PieChart } from './PieChart'

export class DataChart {
    public Chart: any;

    private token: string;

    constructor(public Container, public Model: DataChartModel) {
        this.Container = typeof (Container) === 'string' ? $('#' + Container) : Container;
        this.Container.addClass('ob-igChart');

        this.Model = Model;
        this.Chart = null;
    }

    public Render() {
        switch (this.Model.chartType) {
            case CHART_TYPE.Bar:
                this.Chart = new BarChart(this.Container, this.Model);
                break;
            case CHART_TYPE.Pie:
                this.Chart = new PieChart(this.Container, this.Model);
                break;
            case CHART_TYPE.HorizontalBar:
                this.Chart = new BarChart(this.Container, this.Model);
                break;
        }

        if (this.Chart !== null) {
            this.Chart.Render();
        }

        // Add the open in window button
        if ($.isFunction(this.Model.methods.onLoad)) {
            this.Model.methods.onLoad(this);
        }
    }

    public ToggleLegend() {
        if (this.Chart !== null && $.isFunction(this.Chart.ToggleLegend)) {
            this.Chart.ToggleLegend();
        }
    }

    public ToggleLabels() {
        if (this.Chart !== null && $.isFunction(this.Chart.ToggleLabels)) {
            this.Chart.ToggleLabels();
        }
    }

    public RotateLeft() {
        if (this.Chart !== null && $.isFunction(this.Chart.RotateLeft)) {
            this.Chart.RotateLeft();
        }
    }

    public RotateRight() {
        if (this.Chart !== null && $.isFunction(this.Chart.RotateRight)) {
            this.Chart.RotateRight();
        }
    }

    public Print() {
        if (this.Chart !== null && $.isFunction(this.Chart.Print)) {
            this.Chart.Print();
        }
    }

    public GetImage() {
        let img = null;
        if (this.Chart !== null && $.isFunction(this.Chart.GetImage)) {
            img = this.Chart.GetImage();
        }
        return img;
    }
}
